export default "__VITE_ASSET__ZeMdAP27__"